import React, {useState} from 'react';
import PropTypes from 'prop-types';
import withRouter from 'with-router'
import { bindActionCreators } from 'redux'
import { connect, useSelector, useDispatch } from 'react-redux'
import withStyles from '../../withStylesAdapter';
import classNames from 'classnames';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import TextsmsOutlined from '@mui/icons-material/TextsmsOutlined';
import HelpOutlineOutlined from '@mui/icons-material/HelpOutlineOutlined';
import TrackChangesOutlined from '@mui/icons-material/TrackChangesOutlined';
import InfoTwoTone from '@mui/icons-material/InfoTwoTone';
import SmsTwoTone from '@mui/icons-material/SmsTwoTone';
import MailOutlined from '@mui/icons-material/MailOutlined';
import InfoIcon from '@mui/icons-material/Info';
import InsertChartOutlined from '@mui/icons-material/InsertChartOutlined';
import TranslateOutlined from '@mui/icons-material/TranslateOutlined';
import ChevronRightOutlined from '@mui/icons-material/ChevronRightOutlined';
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router-dom'
//import Joyride from 'react-joyride';
import {Radar, PieChart, Pie, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts';
import RechargePlans from '../../components/RechargePlans';
import API from '../../api/api';
import CircularProgress from '@mui/material/CircularProgress';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import SmallProgressIndicator from '../../components/SmallProgressIndicator.js'
import {Tooltip as MUITooltip} from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import StarsRoundedIcon from '@mui/icons-material/StarsRounded';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import { ResizeObserver } from '@juggle/resize-observer';
import GetSupport from '../../components/GetSupport';
import {BulkTranslationSettings} from '../../components/BulkTranslations';
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import { AutoTranslationsDummy } from '../../components/PricingPlans.js';
import { formatLargeNumber } from '../../helper.js';
import { SOLUTIONS_ROOT_URL } from '../../config/solutionsArticles';

const REACT_APP_ENABLE_AUTO_TRANSLATIONS = window.loadEnv("REACT_APP_ENABLE_AUTO_TRANSLATIONS", process.env.REACT_APP_ENABLE_AUTO_TRANSLATIONS);
const REACT_APP_DASHBOARD_SHOW_STATISTICS_TILE = window.loadEnv("REACT_APP_DASHBOARD_SHOW_STATISTICS_TILE", process.env.REACT_APP_DASHBOARD_SHOW_STATISTICS_TILE);

const onboardingSteps = [
  {
    target: '.languages-section',
    title: 'Languages',
    content: 'In this section you create and manage your different languages.',
    placement: 'bottom',
    spotlightPadding: 0,
    locale: { back: 'Back', close: 'Close', last: 'Last', skip: 'Skip', next: 'Next' },
    disableBeacon: true
  },
  {
    target: '.current-language-select',
    title: 'Current Language',
    content: 'Here you select the current translation language (If you have more than one).',
    placement: 'auto',
    placementBeacon: 'right',
    locale: { back: 'Back', close: 'Close', last: 'Last', skip: 'Skip', next: 'Next' },
    styles: { options: { zIndex: 90000 }},
    //disableBeacon: true
  },
  {
    target: '.current-theme-select',
    title: 'Current Theme',
    content: 'Select the theme you want to work in.',
    placement: 'auto',
    placementBeacon: 'right',
    locale: { back: 'Back', close: 'Close', last: 'Last', skip: 'Skip', next: 'Next' },
    //disableBeacon: true
  },


  {
    target: '.search-form',
    title: 'Search Feature',
    content: 'With your search feature you can find specific translations.',
    placement: 'right',
    placementBeacon: 'right',
    spotlightPadding: 0,
    styles: {options: { textAlign: 'left' }},
    locale: { back: 'Back', close: 'Close', last: 'Last', skip: 'Skip', next: 'Next' },
    //disableBeacon: true
  },
  {
    target: '.side-menu',
    title: 'Translation',
    content: 'Here you can add the translations for all contents you have in Shopify.',
    placement: 'auto',
    spotlightPadding: 0,
    locale: { back: 'Back', close: 'Close', last: 'Last', skip: 'Skip', next: 'Next' },
    //disableBeacon: true
  },
];

const data02 = [
  {
    "name": "Translated Fields",
    "value": 21400
  },
  {
    //"name": "Untranslated Fields",
    //"value": 4567
  },
];





const slideImages = [
  '/files/images/geolizr_banner_1.png',
  '/files/images/geolizr_banner_2_1.png',
  '/files/images/yoast1.png',
  '/files/images/yoast2.png',
  '/files/images/reconvert1.png',
  '/files/images/reconvert2.png',
  '/files/images/boost.jpg',
];

const properties = {
  duration: 10000,
  transitionDuration: 500,
  infinite: true,
  indicators: true,
  arrows: false,
  pauseOnHover: true,
  onChange: (oldIndex, newIndex) => {
    
  }
}

const Slideshow = () => {
  return (
    <div id="bannerLoop" className="slide-container">
      <Slide cssClass="raise-height" {...properties}>
        {/* the banner images were made for this background, it stays the old blue */}
        <div className="each-slide" style={{backgroundColor: '#7077bc'}}>
          <div className="raise-height" style={{backgroundImage: `url('${slideImages[0]}')`, backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain'}}>
            <a href="https://apps.shopify.com/geolizr?utm_source=Shopify&utm_medium=banner&utm_campaign=In-App-Banner" target="_blank" className="cta-btn"></a>
          </div>
        </div>
        <div className="each-slide" style={{backgroundColor: '#7077bc'}}>
          <div className="raise-height" style={{backgroundImage: `url('${slideImages[1]}')`, backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain'}}>
            <a href="https://apps.shopify.com/geolizr?utm_source=Shopify&utm_medium=banner&utm_campaign=In-App-Banner" target="_blank" className="cta-btn"></a>
          </div>
        </div>
      </Slide>
      <span className="banner-label">
        <InfoOutlinedIcon style={{fill: 'white', fontSize: '1rem', margin: '-2px 2px 0 0'}} size="small" />
        Partner App
      </span>
    </div>
  )
}




class TileRow extends React.Component {

  resizeObserver = null;
  resizeTimer = null;

  constructor(props) {
    super(props);

    this.state = {
      showRechargePlans: false,
      showCircle: true,
      steps: onboardingSteps, 
      run: false,
    };
  }
  
  componentDidMount() {
    this.startAutoLoop();

    // Calculate which tile to show
    var mainTile = 'onboarding';
    if(REACT_APP_DASHBOARD_SHOW_STATISTICS_TILE == 'false' && REACT_APP_ENABLE_AUTO_TRANSLATIONS == 'true' && this.props.shop.auto_translations.enabled) mainTile = 'autotranslations';

    this.setState({
      activeMainTile: mainTile,
    }); 
  }

  componentWillReceiveProps(newProps) {}

  componentWillUnmount() {
    this.stopAutoLoop();
    if(this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  onClickGetSupportButton = () => {
    window.FreshWidget.show();
  }

  handleStartTour = () => {
    this.setState({
      run: true,
    });
  }

  callback = (data) => {
    const { action, index, type } = data;

    if(action === 'reset' || action === 'close') {
      this.setState({
        run: false,
      });
    }
  };

  openRechargePlans = () => {
    this.setState({
      showRechargePlans: true
    })
  }

  onCloseRechargePlans = () => {
    this.setState({
      showRechargePlans: false
    })
  }

  onBuyWords = (plan) => {
    API.buyWords(
      plan,
      res => {
        //console.log(res)
      }
    )
  }

  tileLoaded = (ref) => {
    this.resizeObserver = new ResizeObserver((entries) => {
      clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
        const width = entries[0].contentRect.width;

        if(width > 575) {
          this.setState({showCircle: true});
        } else {
          this.setState({showCircle: false});
        }
      }, 100);
    });

    // Listen for errors
    window.addEventListener('error', e => console.log(e.message));
    this.resizeObserver.observe(document.getElementById("autoTranslationTile"));
  }

  setTileMode = (mode) => {
    this.setState({
      progressTileMode: mode,
      lockTileMode: true,
    });
    this.stopAutoLoop();
  }

  startAutoLoop = () => {
    if(!this.state.lockTileMode) {
      clearInterval(this.autoLoop);
      this.autoLoop = setInterval(() => {
        this.setState({progressTileMode: this.state.progressTileMode === 'statistic' ? 'newfields' : 'statistic'});
      }, 10000);
    }
  }

  stopAutoLoop = () => {
    if(this.autoLoop) {
      clearInterval(this.autoLoop);
    }
  }

  _isPastDate(dateString, days) {
    var givenDate = new Date(dateString);
    givenDate.setDate(givenDate.getDate() + days);
    var currentDate = new Date();
    if (currentDate < givenDate) {
      return false; // Given date is in the future
    } else {
      return true; // Given date is in the past or today
    }
  }

  renderAutoTranslationsTile = () => {
    const { t, classes, shop, theme } = this.props;
    const { steps, run, progressTileMode, statisticsLoaded, showCircle } = this.state;
    const pieColor = theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.accentMuted;
    const isNewMerchant = shop.charge ? this._isPastDate(shop.charge.created_at, shop.charge.trialDays) ? false : true : false;
    
    const format = num => {
      const n = String(num), p = n.indexOf('.')
      return n.replace(
        /\d(?=(?:\d{3})+(?:\.|$))/g,
        (m, i) => p < 0 || i < p ? `${m},` : m
      );
    }
    const availableWords = formatLargeNumber(shop.auto_translations.available_words > 0 ? shop.auto_translations.available_words : 0);
    const totalUsedWords = formatLargeNumber(shop.auto_translations.total_used_words);
    const wordsLeft = shop.auto_translations.available_words;
    let colorClass = 'green';
    if(wordsLeft < 250) colorClass = 'yellowgreen';
    if(wordsLeft < 150) colorClass = 'orange'
    if(wordsLeft < 50) colorClass = 'red';

   

    const getFontSize = (str) => {
      let res = 2.75;
      if(str.length === 7) res = 2.5;
      else if(str.length === 8) res = 2.25;
      else if(str.length === 9) res = 2;
      else if(str.length > 9) res = 1.75;
      return res;
    }
    
    return(<Grid size={{ xs: 12, md: 8 }}>
      <Card id="autoTranslationTile" 
        className={classes.card} 
        ref={this.tileLoaded}
      >
        <CardContent className={classNames(classes.cardContent, classes.fluidContent)}>
          <Typography variant="subtitle1" style={{marginLeft: 24, position: 'relative', top: 9, paddingTop: 7, paddingBottom: 7}}>
            {t('autoTranslationsTile.title')}
          </Typography>
          <Divider style={{marginTop: 16, marginBottom: 0}} />  
          <div style={{display: 'flex', 
            //flexDirection: 'row-reverse', 
            position: 'relative', minHeight: 250}}>
            {showCircle &&
              <div style={{minWidth: 300, minHeight: 250, position: 'relative'}}>
                <PieChart width={300} height={250} style={{position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)'}}>
                  {/* Recharts strokes sectors with '#fff' by default - a white rim
                      around the ring on the dark card. */}
                  <Pie data={data02} endAngle={300} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={96} outerRadius={100} fill={pieColor} stroke={theme.palette.background.paper} />
                </PieChart>
                <Fade in={showCircle} style={{ transitionDelay: statisticsLoaded ? `1500ms` : '0ms' }}>
                  <div className={classes.progressNumContent}>                          
                    <Typography variant="h2" style={{ fontSize: `${getFontSize(availableWords)}rem`}} classes={{root: this.props.classes.progressNum}}>
                      {shop.auto_translations.available_words > 0 ? formatLargeNumber(shop.auto_translations.available_words) : 0}</Typography>
                    <Typography variant="p" classes={{root: this.props.classes.progressNumText}}>{t('autoTranslationsTile.wordsLeft')}</Typography>
                  </div>            
                </Fade> 
              </div>
            }
            <div style={{textAlign: 'center', padding: '16px 24px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
              <Typography variant="h4" style={{margin: '0 0 12px 0'}}>
                <TranslateOutlined style={{marginRight: 12, fontSize: 35, verticalAlign: 'top' }} />
                {t('autoTranslationsTile.title')}
              </Typography>
              <Divider variant="middle" />
              <Typography variant="p" style={{marginBottom: 24, color: theme.palette.text.secondary, fontSize: '1.4rem', fontWeight:400, lineHeight: '1.4rem'}}>
                <small>
                  <Trans i18nKey='autoTranslationsTile.usedWordsInfo'>
                    {{availableWords}}
                    {{totalUsedWords}}
                  </Trans>
                </small>
              </Typography>

              <MUITooltip 
                title={
                  <React.Fragment>
                    <InfoIcon
                      style={{
                        float: 'right',
                        position: 'relative',
                        left: 8,
                        bottom: 6
                      }}
                    />
                    <div>
                      <Typography style={{ paddingBottom: 8 }}>
                        <span color="inherit">{t('buyAutoTranslationWordsDialog.tooltipTitle')}</span>
                      </Typography>
                      <span style={{ fontSize: 12 }}>
                        {t('buyAutoTranslationWordsDialog.tooltipDescription')}
                      </span>
                    </div>
                  </React.Fragment>
                } 
                //disableHoverListener={!isNewMerchant} 
                disableHoverListener={true} 
                arrow
              >
                <span>
                  <Button variant="outlined" color="primary" size="medium" onClick={this.openRechargePlans} 
                    //disabled={isNewMerchant} 
                    style={{marginBottom: 16}}
                  >
                    {t('autoTranslationsTile.getMoreWordsButton')} <ChevronRightOutlined style={{margin: '0 -10px 0 10px'}} />
                  </Button>                  
                </span>
              </MUITooltip>

              <BulkTranslationSettings showInModalDialog buttonOnly />
            </div>   
          </div>
        </CardContent>
      </Card>
    </Grid>);
  }

  renderSupportTile = () => {
    const { classes, shop } = this.props;
    const { steps, run, showCircle, currentTile, statisticsLoaded } = this.state;

    return <Card className={classes.card}>
      <CardContent className={classes.specialCardContent}>

        <div>
          <Typography className={classes.specialCardHeadline} gutterBottom variant="p" style={{margin:0}}>
            Support
          </Typography>
          <Typography variant="body1" className={classes.cardBody} style={{ fontSize:'0.875rem' }}>
            No solution found in our <a href={SOLUTIONS_ROOT_URL} target="_blank" rel="noopener noreferrer" style={{textDecoration: 'underline'}}>documentation</a>?<br/>Click "Get Support" and briefly describe your problem.
          </Typography>

          <div>
            <Button 
              variant="outlined" 
              size="medium"
              onClick={this.handleStartTour}
              style={{marginTop: 16, color: 'rgba(0,0,0,.5)', borderColor: '#ffffff', width: '100%'}}
            >
              Quick Tour <ChevronRightOutlined style={{margin: '0 -10px 0 10px', fill: '#ffffff'}} />
            </Button>

            <a href={SOLUTIONS_ROOT_URL} target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none'}}>
              <Button 
                variant="outlined" 
                size="medium"
                style={{marginTop: 16, color: 'rgba(0,0,0,.5)', borderColor: '#ffffff', width: '100%'}}
              >
                Documentation <ChevronRightOutlined style={{margin: '0 -10px 0 10px', fill: '#ffffff'}} />
              </Button>
            </a>
          </div>
        </div>

        <div>
          <Divider style={{marginTop: 16, marginBottom: 16, backgroundColor: 'rgba(255, 255, 255, 0.23)'}} />
          <Button 
            variant="contained" 
            size="large"
            fullWidth
            classes={{label: classes.specialCardBtn}}
            onClick={(event) => {this.onClickGetSupportButton(event)}}
          >
            Get Support <MailOutlined style={{marginLeft: 16}} />
          </Button>
        </div>
      </CardContent>
    </Card>;
  }

  render() {
    const { t, classes, shop } = this.props;
    const { steps, run, showCircle, currentTile, statisticsLoaded } = this.state;
    const format = num => {
      const n = String(num), p = n.indexOf('.')
      return n.replace(
        /\d(?=(?:\d{3})+(?:\.|$))/g,
        (m, i) => p < 0 || i < p ? `${m},` : m
      );
    }
    
    let wordsLeft = shop.auto_translations.available_words;
    let colorClass = 'green';
    if(wordsLeft < 250) colorClass = 'yellowgreen';
    if(wordsLeft < 150) colorClass = 'orange'
    if(wordsLeft < 50) colorClass = 'red';

    return(<React.Fragment>
      <Grid container alignItems="stretch" alignContent="stretch" spacing={3} style={{ marginTop: 8 }}>
  
        {/*<Joyride
          continuous
          spotlightClicks
          disableScrolling
          showProgress
          showSkipButton
          steps={steps}
          run={run}
          callback={this.callback}
          styles={{
            options: {
              zIndex: 9000,
              primaryColor: '#1a237e',
            }
          }}
        />*/}
        
        {this.state.activeMainTile === 'autotranslations' && 
        <>
          {this.props.charge.name !== 'free' ?
            this.renderAutoTranslationsTile()
          :
            <AutoTranslationsDummy />
          }
        </>
        }

        <Grid size={{ xs: 12, md: 4 }}>
          { 
            //this.renderSupportTile()
          }
          <Card className={classes.card}>
            <CardContent className={classes.specialCardContent} style={{padding: 0, paddingBottom: '0px !important'}}>
              <Slideshow />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <RechargePlans
        visible={this.state.showRechargePlans}
        onClose={this.onCloseRechargePlans}
        onBuy={this.onBuyWords}
      />

      {/*
        <GetSupport
          onStartTour={this.handleStartTour} 
        />
      */}

      
    </React.Fragment>);
  }
}

const styles = theme => ({
  chartContainer: {
    marginLeft: -100,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },

  radarChart: {
    padding: '10px 0',
    '& text': {
      fontSize: '.8rem',
    },
    '& .recharts-surface': {
      height: '230px !important',
      overflow: 'initial'
    }
  },


  autoTransText: {
    color: `${theme.palette.text.secondary} !important`,
    fontSize: '1.75rem',
    fontWeight: '400 !important',
  },


  media: {
    width: '100%',
    height: 200,
    backgroundColor: theme.palette.background.paper,
  },
  icon: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: .1,
    transform: 'rotate(-15deg)'
  },

  card: {
    height: '100%',
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    background: theme.palette.mode === 'dark'
      ? 'linear-gradient(360deg, rgba(30,30,30,1) 0%, rgba(38,38,38,1) 100%)'
      : 'linear-gradient(360deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.9) 100%)',
    position: 'relative',
    padding: '16px !important',
    [theme.breakpoints.down('md')]: {
      minHeight: 0,
    },
  },
  statistics: {
    padding: '16px 0 0 0 !important',
  },
  fluidContent: {
    padding: '0 !important',
  },
  cardHeadline: {
    margin: '.5rem 0',
    fontWeight: 400,
    color: `${theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.accentMuted} !important`,
  },
  cardHeadline2: {
    fontSize: '1.8rem',
    fontWeight: 400,
    color: `${theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.accentMuted} !important`,
  },
  cardBody: {
    margin: '20px 0 0 0',
    color: theme.palette.text.secondary,
  },
  cardBtn: {
    marginTop: '.5rem 0',
    color: '#fff',
  },

  specialCardContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    height: '100%',
    background: theme.palette.mode === 'dark'
      ? 'linear-gradient(360deg, rgba(18,24,86,1) 0%, rgba(26,35,126,1) 100%)'
      : 'linear-gradient(360deg, rgba(26,35,126,1) 0%, rgba(26,35,126,0.9) 100%)',
    position: 'relative',
    //paddingBottom: '16px !important',
    [theme.breakpoints.down('md')]: {
      minHeight: 0,
    },
    '& *': {
      color: '#fff',
      '& path': {
        color: 'rgba(0, 0, 0, 0.7) !important',
      }
    },
  },
  specialCardHeadline: {
    margin: '.5rem 0',
    fontWeight: 400,
    color: '#fff !important',
  },
  specialCardBtn: {
    marginTop: '.5rem 0',
    borderColor: 'rgba(255, 255, 255, 0.23)',
    color: 'rgba(0, 0, 0, 0.7) !important',
  },
  progressNumContent: {
    position: 'absolute',
    top: '50%',
    left: 0,
    transform: 'translateY(-50%)',
    textAlign: 'center',
    width: 300,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  progressNum: {
    //color: '#1a237e !important',
    fontWeight: '300 !important',
  },
  progressNumText: {
    color: `${theme.palette.text.secondary} !important`,
    fontWeight: '400 !important',
  },
  // Statusfarben im Dark Mode aufhellen, sonst verschwinden green/red auf dunklem Grund.
  green: {
    color: `${theme.palette.mode === 'dark' ? '#66bb6a' : 'green'} !important`,
  },
  yellowgreen: {
    color: `${theme.palette.mode === 'dark' ? '#d4e157' : 'yellow'} !important`,
  },
  orange: {
    color: `${theme.palette.mode === 'dark' ? '#ffa726' : 'orange'} !important`,
  },
  red: {
    color: `${theme.palette.mode === 'dark' ? '#ef5350' : 'red'} !important`,
  },
  label: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    borderRadius: 3,
    padding: '0 8px',
    wordBreak: 'normal',
    minWidth: '50px',
    textAlign: 'center'
  }
});

const mapStateToProps = ({ shop, stats }) => ({
  stats: stats,
  editLanguage: shop.shop.edit_language,
  shopPlan: shop.shop.charge.name,
  shopUrl: shop.shop.url,
  langify_features: shop.shop.langify_features,
  charge: shop.shop.charge
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {},
    dispatch
  )

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(TileRow))))